export default {
	city: '',
	pageTitle: '', //页面标题
	pageFooterType: '', //页面底部类型 
	preRouter: {}, //上个路由
	order_status_arr: ['待支付', '支付成功', '支付失败', '支付超时', '交易取消', '已删除', '退款中', '退款成功', '退款失败'],
	order_money: 199,
	professionalTypeList: [],
	loginSuccess: false,
	userInfo: {},
}
